import { LogOut } from "lucide-react";

interface UserInfoBarProps {
	accountName: string | null;
	nodeCount: number;
	linkCount: number;
	queueCount: number;
	onLogout: () => void;
}

export default function UserInfoBar({ accountName, nodeCount, linkCount, queueCount, onLogout }: UserInfoBarProps) {
	return (
		<div className="absolute bottom-4 left-4 z-30 flex items-center gap-2">
			<div className="flex items-center gap-2 px-3 py-2 bg-slate-800/80 backdrop-blur-xl border border-slate-700/50 rounded-xl shadow-lg">
				<div className="w-7 h-7 bg-linear-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
					<span className="text-white font-bold text-xs">{accountName?.[0]?.toUpperCase() ?? "U"}</span>
				</div>
				<span className="text-sm text-slate-300 font-medium max-w-30 truncate">{accountName}</span>
				<button
					onClick={onLogout}
					className="p-1.5 text-slate-400 hover:text-red-400 rounded-lg hover:bg-red-400/10 transition-all"
					title="Sign out"
				>
					<LogOut className="w-4 h-4" />
				</button>
			</div>
			<div className="px-2.5 py-2 bg-slate-800/80 backdrop-blur-xl border border-slate-700/50 rounded-xl shadow-lg">
				<span className="text-xs text-slate-500">{nodeCount} nodes · {linkCount} relations · {queueCount} queued</span>
			</div>
		</div>
	);
}
